import { useEffect, useState } from 'react';
import { selectEntryChannelsLoadingPag, selectEntryChannelsPag } from '../../redux/entryChannels/selectors';
import { AdminTable } from './AdminTable';
import { useDispatch, useSelector } from 'react-redux';
import { Column } from 'devextreme-react/data-grid';
import { createEntryChannel, deleteEntryChannel, editEntryChannel, getEntryChannelsPag } from '../../redux/entryChannels/thunks';
import { openModal } from '../../redux/modal/modalSlice';
import { selectBrandPagedList, selectBrandPagedListLoading } from '../../redux/brands/selectors';
import { createBrand, deleteBrand, getBrandsPag, updateBrand } from '../../redux/brands/thunks';
import { validateEmail } from '../../commonFunctions/commonFunctions';

const initialSortOptions = {
  columna: 'brandId',
  sortOrderAsc: true,
};

function BrandManagement() {
  const brands = useSelector(selectBrandPagedList);
  const dispatch = useDispatch();
  const loading = useSelector(selectBrandPagedListLoading);
  const [sortOptions, setSortOptions] = useState(initialSortOptions);

  useEffect(() => {
    getListBrands(mapPageInfo(brands));
  }, []);

  function mapPageInfo(brandsData) {
    return {
      pageIndex: brandsData.pageIndex ?? 0,
      pageSize: brandsData.pageSize ?? 10,
      orderByField: brandsData.columna ?? 'brandId',
      orderByAscending: brandsData.sortOrderAsc ?? true,
    };
  }

  const getListBrands = (pageInfo) => {
    let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`;
    if (pageInfo.searchString?.trim().length > 0) {
      query = query.concat(`&searchString=${pageInfo.searchString.trim()}`);
    }
    if (pageInfo.orderByField) {
      query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`);
    }
    dispatch(getBrandsPag({ query }));
  };

  const columnsEntryChannels = [
    <Column sortIndex={1} key={'brand-1'} dataField="brandId" caption="Id" allowEditing={false} allowCreating={false} />,
    <Column key={'brand-2'} dataField="brandName" caption="Nome" />,
    <Column key={'brand-3'} dataField="email" caption="E-mail" />,
  ];

  function isValidFormData(data) {
    if (data.brandName.trim() === '') {
      dispatch(openModal({ type: 'warning', message: 'Por favor, preencha o campo Nome' }));
      return false;
    }

    const brandNameExists = brands.elements.some((brand) => brand.brandName.toLowerCase() === data.brandName.trim().toLowerCase());
    if (brandNameExists && data.brandName.trim().toLowerCase() !== brands.elements.find((brand) => brand.brandId === data.brandId)?.brandName.toLowerCase()) {
      dispatch(openModal({ type: 'warning', message: 'O nome inserido já existe para outra montadora.' }));
      return false;
    }

    if (data.email.trim() === '') {
      dispatch(openModal({ type: 'warning', message: 'Por favor, preencha o campo E-mail' }));
      return false;
    }
    if (!validateEmail(data.email.trim())) {
      dispatch(openModal({ type: 'warning', message: 'Por favor, preencha um e-mail válido' }));
      return false;
    }
    return true;
  }

  function handleSaveNewEntryChannelClick(value, closeCreateModal) {
    if(!isValidFormData(value))
        return;

    const brandParams = { body: value };
    dispatch(createBrand(brandParams)).then((data) => {
      if (data.error) dispatch(openModal({ type: 'warning', message: data.error.message }));
      else {
        getListBrands(mapPageInfo({ ...brands, ...sortOptions }));
        closeCreateModal();
      }
    });
  }

  const handleEditClick = (value, closeEditModal) => {
    if(!isValidFormData(value))
        return;

    const params = {
      param: value.brandId,
      body: value,
    };

    dispatch(updateBrand(params)).then((data) => {
      if (data.error) dispatch(openModal({ type: 'warning', message: data.error.message }));
      else {
        dispatch(openModal({ type: 'success', message: 'Montadora atualizada com sucesso!' }));
        getListBrands(mapPageInfo({ ...brands, ...sortOptions }));
        closeEditModal();
      }
    });
  };

  const handleDeleteClick = (id, closeDeleteModal) => {
    dispatch(deleteBrand({ param: id })).then((data) => {
      if (data.error) dispatch(openModal({ type: 'warning', message: data.error.message }));
      else {
        dispatch(openModal({ type: 'success', message: 'Montadora excluída com sucesso!' }));

        let updatedPageIndex = brands.pageIndex;

        if (brands.elements.length === 1) {
          updatedPageIndex = Math.max(0, brands.pageIndex - 1);
        }

        const updatedBrands = {
          ...brands,
          pageIndex: updatedPageIndex,
        };

        getListBrands(mapPageInfo({ ...updatedBrands, ...sortOptions }));
        closeDeleteModal();
      }
    });
  };

  function allowDelete(rowData) {
    return true;
    //return rowData.data.custom;
  }

  return (
    <div style={{ width: '100%' }}>
      <AdminTable
        sectionTitle={'Montadora'}
        masterTitle={'item'}
        itemIdField={'brandId'}
        itemDescriptionField={'brandName'}
        loading={loading}
        getData={getListBrands}
        dataSource={brands}
        columnasTabla={columnsEntryChannels}
        onCreate={handleSaveNewEntryChannelClick}
        onDelete={handleDeleteClick}
        onEdit={handleEditClick}
        numElements={[10, 20, 30]}
        allowDelete={allowDelete}
        sortField={sortOptions}
        setsortField={setSortOptions}
      />
    </div>
  );
}
export default BrandManagement;
